
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.758 0H8.508a2.11 2.11 0 00-2.11 2.11v5.203c0 .386.317.703.704.703a.705.705 0 00.703-.703V2.109c0-.386.316-.703.703-.703h11.25c.387 0 .703.317.703.703V21.89a.705.705 0 01-.703.704H8.508a.705.705 0 01-.703-.704v-5.203a.705.705 0 00-.703-.703.705.705 0 00-.703.703v5.203A2.11 2.11 0 008.508 24h11.25a2.11 2.11 0 002.11-2.11V2.11A2.11 2.11 0 0019.757 0z"}}),_c('path',{attrs:{"d":"M16.297 11.426l-2.879-2.031a.706.706 0 00-.813 1.152l1.067.75H2.836c-.387 0-.703.317-.703.703s.316.703.703.703h10.836l-1.066.754a.7.7 0 00-.168.977c.222.32.66.394.98.172l2.879-2.031a.705.705 0 000-1.149z"}})])
          )
        }
      }
    